{
  "nav": {
    "read": "Read",
    "write": "Write",
    "about": "About",
    "me": "Me"
  },
  "letter": {
    "by": "By",
    "writtenOn": "Written on",
    "inResponseTo": "In response to",
    "when": "When?",
    "about": "About?",
    "approvedBy": "Approved by",
    "sources": "Sources?",
    "status": "Status",
    "byAuthor": "by {{name}}",
    "contribute": "Contribute",
    "noLetterYet": "No letter yet.",
    "responses_one": "{{count}} response",
    "responses_other": "{{count}} responses",
    "respond": "Respond to this message"
  },
  "write": {
    "workspaceTitle": "Write",
    "workspaceHint": "Your drafts and letters in review.",
    "newLetter": "+ New letter"
  },
  "editor": {
    "title": "Title",
    "text": "Text",
    "sources": "Sources (one URL per line)",
    "sourcesPlaceholder": "https://example.org/article\nhttps://another-source.com/resource",
    "saveDraft": "Save as draft",
    "sendForReview": "Send for peer review",
    "saving": "Saving…",
    "submitting": "Submitting…",
    "savedDraft": "Draft saved.",
    "sentForReview": "Letter sent for peer review.",
    "saveFailed": "Could not save the letter.",
    "submitFailed": "Could not submit the letter for review.",
    "statusRejected": "Rejected",
    "wordsLeft": "{{count}} words left"
  },
  "review": {
    "prompt": "This letter is awaiting your review.",
    "approve": "Approve",
    "reject": "Reject",
    "rejectPrompt": "Why are you rejecting this letter? (the author will read your comment)",
    "notifyVoteRecorded": "Your vote has been recorded.",
    "notifyPublished": "Letter published — the approval threshold has been reached.",
    "notifyRejected": "Letter returned to the author — the rejection threshold has been reached.",
    "failed": "Could not record your vote."
  },
  "limit": {
    "todayLabel": "Today",
    "actions": "{{used}}/{{max}} actions"
  },
  "closed": {
    "title": "The network is closed",
    "subtitle": "Writing is paused between 10pm and 7am in your timezone.",
    "comeBack": "Come back after 7am to write."
  },
  "about": {
    "title": "A kind network",
    "subtitle": "Peer-reviewed, federated, post-growth",
    "keyElementsTitle": "Rules",
    "items": {
      "perDay": { "title": "17 per day", "body": "A maximum of 17 actions a day, as the number of syllables in a Haiku." },
      "noScroll": { "title": "No scroll", "body": "Reading happens 1 text at a time, followed by the answers." },
      "peerReviewed": { "title": "Peer reviewed", "body": "Moderation happens a priori, by the peers." },
      "sourced": { "title": "Sourced", "body": "Texts are presented and annotated with context & references." },
      "singleFeatured": { "title": "Single-featured", "body": "No job board, training, quiz, whatever… Just a place to discuss with peers." },
      "noAds": { "title": "No advertising", "body": "Just a community driven, open source network." },
      "interoperable": { "title": "Interoperable", "body": "Uses open, interoperable infrastructure." },
      "nig": { "title": "NIG compliant", "body": "Fully embraces the NIG framework for Numérique d'Intérêt Général." },
      "collective": { "title": "Built for Collective Intelligence", "body": "Positive, respectful and slow." }
    },
    "pillarsTitle": "Page structure",
    "pillars":{
      "who": {
        "title": "Who?",
        "sub": "Who I am",
        "detail": "Where am I speaking from? What are my beliefs? What are my views?"
      },
      "what": {
        "title": "What?",
        "sub": "What I say",
        "detail": "What is it about? What is the topic? In what tense?"
      },
      "proof": {
        "title": "Proof?",
        "sub": "What I know",
        "detail": "Sources, traceability, contextual details (fact-checking)"
      }
    },
    "credits":{
      "title": "Credits",
      "text": "Design: Arnaud Levy + Nicolas Pariès + Anthony Ferretti.<br>Logotype: Arnaud Levy. Development: noesya. Typefaces: Adelphe Floréal, Bricolage Grotesque. Source code: <a href=\"http://github.com/noesya/akindnetwork/\" target=\"_blank\">github.com/noesya/akindnetwork/</a>. Hosting: Infomaniak. Stack: ActivityPods."
    }
  },
  "me": {
    "title": "Me",
    "drafts": "Drafts",
    "inReview": "In review",
    "published": "Published",
    "toReview": "Peers to review",
    "emptyDrafts": "No drafts yet.",
    "untitledDraft": "Untitled",
    "status": {
      "draft": "Draft",
      "inReview": "In review",
      "published": "Published"
    },
    "emptyReview": "Nothing to review.",
    "emptyPublished": "No published letter yet.",
    "languageLabel": "Language",
    "account": "Account",
    "connectPod": "Connect my Pod",
    "connectPodDisabled": "Auth not configured — demo mode",
    "logout": "Sign out"
  },
  "login": {
    "title": "Connect my Pod",
    "hint": "Enter the address of your ActivityPods Pod provider.",
    "podProvider": "Pod provider",
    "connect": "Connect",
    "connecting": "Redirecting…",
    "cancel": "Cancel",
    "back": "Back",
    "finishing": "Finishing sign-in…",
    "error": "Sign-in error",
    "unconfigured": "Authentication isn't configured yet. Set VITE_FRONTEND_URL in the .env to enable Solid login."
  },
  "language": {
    "switch": "FR"
  },
  "demo": {
    "banner": "Example data — you're exploring the prototype.",
    "connect": "Connect my Pod",
    "disabledHint": "Connect your Pod to save."
  },
  "user": {
    "publishedLetters": "Published letters",
    "noLetters": "This person hasn't published any letter yet."
  },
  "source": {
    "open": "Open source"
  }
}
